export function decimalInput(value: string | number | undefined, fallback = '') {
  if (value === undefined || value === '') return fallback;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? String(parsed) : String(value);
}

export function percentageInput(ratio: string) {
  return decimalInput(Number((Number(ratio) * 100).toFixed(2)));
}

export function percentageRatio(percentage: string) {
  return String(Number((Number(percentage) / 100).toFixed(4)));
}

export function numberError(value: string, options: { optional?: boolean; positive?: boolean; integer?: boolean; max?: number; precision?: number } = {}) {
  if (!value.trim()) return options.optional ? undefined : '값을 입력해 주세요.';
  const precision = options.precision ?? 4;
  const pattern = options.integer ? /^\d+$/ : new RegExp(`^\\d+(?:\\.\\d{1,${precision}})?$`);
  if (!pattern.test(value) || !Number.isFinite(Number(value))) return options.integer ? '0 이상의 정수로 입력해 주세요.' : `0 이상의 숫자를 소수 ${precision}자리까지 입력해 주세요.`;
  if (options.positive && Number(value) <= 0) return '0보다 큰 값을 입력해 주세요.';
  const maximum = options.max ?? 99_999_999.9999;
  if (Number(value) > maximum) return `${maximum.toLocaleString('ko-KR')} 이하로 입력해 주세요.`;
  return undefined;
}

export function nameError(value: string) {
  if (!value.trim()) return '이름을 입력해 주세요.';
  if ([...value.trim()].length > 100) return '100자 이하로 입력해 주세요.';
  return undefined;
}

export function dateError(value: string, from?: string, to?: string) {
  const parsed = new Date(`${value}T00:00:00Z`);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || Number.isNaN(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== value) return '올바른 날짜를 입력해 주세요.';
  if (from && value < from) return `${from} 이후 날짜를 선택해 주세요.`;
  if (to && value >= to) return `${to} 이전 날짜를 선택해 주세요.`;
  return undefined;
}
